export default __webpack_public_path__ + "static/Registration-1169344a068c8a4739a60466be48fbc2.jpg";